import { AnyAction } from "redux";
import {
  COMING_FROM_CASE,
  REFERRAL_FOR,
  REFERRAL_INCLUSION_TEAM,
  REFERRAl_REASON,
  REFERRAL_OTHER_DETAILS,
  CLEAR_REFERRAL_INFO,
  COMING_FROM_REFERRAL,
  REFERRAL_ADDITIONAL_DETAILS,
  REFERRAL_ACCOUNT_BALANCE,
  WO_REDIRECT_FROM_EMAIL,
  ASSET_BACK_COUNTER,
  ASSET_ARRAY,
  RELEASE_ASSET_ARRAY,
  REMOVE_ASSET_ARRAY,
  FINISH_JOURNEY,
  COMING_FROM_CASE_LIST,
  SERVICE_CARD_DATA,
  GAS_CARD_DATA,
  PREVIOUS_PAGE,
  SEARCH_TYPE_ASSIGN_TO_ME_DATA,
  SEARCH_TYPE_SORT_DATA_REMOVE,
  SEARCH_TYPE_ASSIGN_TO_ME_DATA_REMOVE,
  SEARCH_TYPE_SORT_DATA,
  SEARCH_TYPE_SERVICE_REQUEST_REMOVE,
  SEARCH_TYPE_SERVICE_REQUEST,
  SEARCH_TYPE_WORKORDER_REMOVE,
  SEARCH_TYPE_WORKORDER,
  SEARCH_TYPE_PROPERTY_REMOVE,
  SEARCH_TYPE_PROPERTY,
  SEARCH_TYPE_CUSTOMER_REMOVE,
  SEARCH_TYPE_CUSTOMER,
  DMC_DATA,
  DMC_ANS_DATA,
  REMOVE_DMC_DATA,
  STORE_SORDAMP,
  RESET_FINANCIAL,
  API_ERRORS,
  DUPLICATE_DMC_ANS_DATA,
  REFERRAL_DEBT_TYPES,
  REFERRAL_REASON_REFERENCE_DATA,
  REFERRAL_NOSP_DETAILS,
  NOSP_REFERENCE_DATA,
  SAVE_NOSP_DETAILS_PAYLOAD,
  IS_HHSRS_ENABLED,
  HHSRS_OPTION,
  HAZARD_TYPE,
  SAVERITY_SCORE,
  ASSET_SUBTYPE,
  PARENT_ASSET_TYPE
} from "../actionTypes";

const initialState = {
  financialReferralData: {
    referralFor: "",
    FinancialInclusionTeam: "",
    ReferralReason: [],
    ReferralOtherDetails: "",
    ReferralDebtTypes: [],
    ReferralPriorityDebtTypes: [],
    ReferralNonPriorityDebtTypes: [],
    NospDetails: [],
    nospDetailsPayload:[]
  },
  isComingFromReferral: false,
  referralDetails: "",
  referralReasonReferenceData: [],
   nospReferenceData: [],
  referralAccountBalance: "",
  isComingFromCase: false,
  woRedirectFromEmail: false,
  assetBackCounter: 0,
  assetArrayData: [],
  previousPageName: "",
  isComingFromCaseList: false,
  filterSortData: "",
  assignToMeData: false,
  DMCData: {},
  DMCAnsData: {},
  serviceCardData: {},
  gasCardData: {},
  sordamp: "",
  searchTypeCustomer: {
    setCustomerStatus: "",
    setTenancyType: ""
  },
  searchTypeProperty: {
    setPropertyStatus: "",
    setPropertyType: ""
  },
  searchTypeWorkOrder: {
    setWorkOrderPropertyType: "",
    setStatusWorkOrderType: "",
    setPriorityWorkOrder: ""
  },
  searchTypeServiceRequest: {
    setCasePropertyType: "",
    setCaseStatusFilterType: ""
  },
  isJourneyFinish: false,
  workOrderCaseDataForDMC: {},
  APIerrors: [],

  duplicatedmcansdata:{},
  isHHSRSEnabled:false,
  saveHHSRSOptionValue: "no",
  saveHazardType:"",
  saveSaverityScore:"",
  parentAssetType:null,
  assetSubType:null
};

export const FinancialReferralReducer = (
  state: any = initialState,
  action: AnyAction
) => {
  switch (action.type) {
    case RESET_FINANCIAL:
      return initialState;
    case REFERRAL_FOR:
      return {
        ...state,
        financialReferralData: {
          ...state.financialReferralData,
          referralFor: action.payload,
        },
      };
    case REFERRAL_INCLUSION_TEAM:
      return {
        ...state,
        financialReferralData: {
          ...state.financialReferralData,
          FinancialInclusionTeam: action.payload,
        },
      };
    case REFERRAl_REASON:
      return {
        ...state,
        financialReferralData: {
          ...state.financialReferralData,
          ReferralReason: action.payload,
        },
      };
    case REFERRAL_OTHER_DETAILS:
      return {
        ...state,
        financialReferralData: {
          ...state.financialReferralData,
          ReferralOtherDetails: action.payload,
        },
      };
    case CLEAR_REFERRAL_INFO:
    return {
      ...state,
      financialReferralData: {
        referralFor: "",
        FinancialInclusionTeam: "",
        ReferralReason: [],
        ReferralOtherDetails: "",
        ReferralDebtTypes: [],
        ReferralPriorityDebtTypes: [],
        ReferralNonPriorityDebtTypes: [],
        NospDetails: [],
        nospReferenceData: [],
        nospDetailsPayload: []
      },
      isComingFromReferral: false,
      referralDetails: "",
    };
    case COMING_FROM_REFERRAL:
      return {
        ...state,
        isComingFromReferral: action.payload,
      };
    case REFERRAL_ADDITIONAL_DETAILS:
      return {
        ...state,
        referralDetails: action.payload,
      };
    case REFERRAL_ACCOUNT_BALANCE:
      return {
        ...state,
        referralAccountBalance: action.payload,
      };
    case COMING_FROM_CASE:
      return {
        ...state,
        isComingFromCase: action.payload,
      };
    case ASSET_BACK_COUNTER:
      return {
        ...state,
        assetBackCounter: action.payload,
      };
    case FINISH_JOURNEY:
      return {
        ...state,
        isJourneyFinish: action.payload,
      };
    case ASSET_ARRAY:
      return {
        ...state,
        assetArrayData: [...state.assetArrayData, action.payload],
      };
    case RELEASE_ASSET_ARRAY:
      return {
        ...state,
        assetArrayData: [],
      };
    case REMOVE_ASSET_ARRAY:
      return {
        ...state,
        assetArrayData: [...state.assetArrayData.slice(0, -1)],
      };
    case WO_REDIRECT_FROM_EMAIL:
      return {
        ...state,
        woRedirectFromEmail: action.payload,
      };
    case COMING_FROM_CASE_LIST:
      return {
        ...state,
        isComingFromCaseList: action.payload,
      };
    case SERVICE_CARD_DATA:
      return {
        ...state,
        serviceCardData: action.payload
      }
    case GAS_CARD_DATA:
      return {
        ...state,
        gasCardData: action.payload
      }
    case PREVIOUS_PAGE:
      return {
        ...state,
        previousPageName: action.payload
      }
      case DMC_DATA:
        return {
          ...state,
          DMCData:action.payload
        }  
      case DMC_ANS_DATA:
        return {
          ...state,
          DMCAnsData:action.payload
        }  
      case REMOVE_DMC_DATA:
        return{
          ...state,
          DMCAnsData:{},
          DMCData:{}
        }  
      case STORE_SORDAMP:
        return {
          ...state,
          sordamp:action.payload
        } 
     case SEARCH_TYPE_CUSTOMER:
        return {
          ...state,
          searchTypeCustomer: action.payload  
        } 
      case SEARCH_TYPE_CUSTOMER_REMOVE:
        return {
          ...state,
          searchTypeCustomer: {
            setCustomerStatus: "",
            setTenancyType: "",
          }
        } 
      case SEARCH_TYPE_PROPERTY:
        return {
          ...state,
          searchTypeProperty: action.payload
        }
      case SEARCH_TYPE_PROPERTY_REMOVE:
        return {
          ...state,
          searchTypeProperty: {
            setPropertyStatus: "",
            setPropertyType:""
          }
        }  
      case SEARCH_TYPE_WORKORDER:
        return {
          ...state,
          searchTypeWorkOrder: action.payload
        }  
        case SEARCH_TYPE_WORKORDER_REMOVE:
          return {
            ...state,
            searchTypeWorkOrder: {
              setWorkOrderPropertyType: "",
              setStatusWorkOrderType: "",
              setPriorityWorkOrder: ""
            }
          }  
      case SEARCH_TYPE_SERVICE_REQUEST:
        return {
          ...state,
          searchTypeServiceRequest: action.payload
        } 
      case SEARCH_TYPE_SERVICE_REQUEST_REMOVE:
        return {
          ...state,
          searchTypeServiceRequest: {
            setCasePropertyType: "",
            setCaseStatusFilterType: ""
          }
        }    
      case SEARCH_TYPE_SORT_DATA:
        return {
          ...state,
          filterSortData: action.payload
        }    
        case SEARCH_TYPE_SORT_DATA_REMOVE:
          return {
            ...state,
            filterSortData: ""
          }   
          case SEARCH_TYPE_ASSIGN_TO_ME_DATA:
        return {
          ...state,
          assignToMeData: action.payload
        }    
        case SEARCH_TYPE_ASSIGN_TO_ME_DATA_REMOVE:
          return {
            ...state,
            assignToMeData : false
          }  
          case API_ERRORS:
        return {
          ...state,
          APIerrors: action.payload,
        }; 
           case DUPLICATE_DMC_ANS_DATA:
          return {
            ...state,
            duplicatedmcansdata : action.payload
          };
          case REFERRAL_DEBT_TYPES: {
            if (Array.isArray(action.payload)) {
              return {
                ...state,
                financialReferralData: {
                  ...state.financialReferralData,
                  ReferralDebtTypes: action.payload,
                },
              };
            }

            const all = Array.isArray(action.payload?.all) ? action.payload.all : [];
            const priority = Array.isArray(action.payload?.priority) ? action.payload.priority : [];
            const nonPriority = Array.isArray(action.payload?.nonPriority) ? action.payload.nonPriority : [];

            return {
              ...state,
              financialReferralData: {
                ...state.financialReferralData,
                ReferralDebtTypes: all,
                ReferralPriorityDebtTypes: priority,
                ReferralNonPriorityDebtTypes: nonPriority,
              },
            };
          };
          case REFERRAL_REASON_REFERENCE_DATA:
          return {
            ...state,
            referralReasonReferenceData: action.payload,
          };
           case NOSP_REFERENCE_DATA:
          return {
            ...state,
            nospReferenceData: action.payload,
          };
          case REFERRAL_NOSP_DETAILS: {
      const nosp = Array.isArray(action.payload) ? action.payload : [];
      return {
        ...state,
        financialReferralData: {
          ...state.financialReferralData,
          NospDetails: nosp,
        },
      };
    };    
      case SAVE_NOSP_DETAILS_PAYLOAD: {
            const nospDetails = Array.isArray(action.payload) ? action.payload : [];
            return {
              ...state,
              nospDetailsPayload: {
                nospDetails,
              },
            };
          }
          case IS_HHSRS_ENABLED:
            return {
              ...state,
              isHHSRSEnabled:action.payload
            }
          case HHSRS_OPTION :
            return {
              ...state,
              saveHHSRSOptionValue:action.payload
            }
          case HAZARD_TYPE:
            return {
              ...state,
              saveHazardType:action.payload
            } 
          case SAVERITY_SCORE:
            return {
              ...state,
              saveSaverityScore:action.payload
            }  
          case ASSET_SUBTYPE:
            return {
              ...state,
              assetSubType:action.payload
            } 
          case PARENT_ASSET_TYPE:
            return {
              ...state,
              parentAssetType:action.payload
            }     

    default:
      return state;
  }
};
